import { NgModule } from '@angular/core';
import { backendSearch, SearchModule } from '@shared/datastore/core';
import { searchFreelancersBackend } from './search-freelancers.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { transformSearchFreelancers } from './search-freelancers.transformers';

backendSearch.searchFreelancers = searchFreelancersBackend;

@NgModule({
  imports: [
    SearchModule.forFeature('searchFreelancers', transformSearchFreelancers),
    /* DatastoreBackendModule.forFeature(
      'searchContest',
      searchContestTransformer,
    ),*/
  ],
})
export class DatastoreSearchFreelancersModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-freelancers/search-freelancers.module.ts